import { Link } from "react-router-dom";
import { Check, ChevronRight, Wrench } from "lucide-react";
import { MediaImage } from "../MediaImage";
import { useSiteMedia } from "../../lib/siteMedia";
import { PhoneLink, QuoteButton, WhatsAppButton } from "../home/CtaButtons";

export const Crumbs = ({ items }) => (
  <nav aria-label="Kruimelpad" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1.5 text-[13px] text-slate-500">
      {items.map((it, i) => (
        <li key={it.href} className="inline-flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-slate-400" aria-hidden="true" />}
          {i === items.length - 1 ? <span className="font-medium text-ink" aria-current="page">{it.label}</span>
            : <Link to={it.href} className="hover:text-maas">{it.label}</Link>}
        </li>
      ))}
    </ol>
  </nav>
);

export const ProductHero = ({ page, crumbs }) => {
  const media = useSiteMedia();
  const { hero } = page;
  return (
    <section aria-labelledby="product-title" className="relative overflow-hidden bg-white" data-testid="product-hero">
      <div className="hero-grid absolute inset-y-0 right-0 hidden w-[50%] lg:block" aria-hidden="true" />
      <div className="container-tight relative grid items-center gap-10 pb-12 pt-6 sm:pt-8 lg:grid-cols-12 lg:gap-12 lg:pb-16">
        <div className="reveal-hero lg:col-span-6">
          <Crumbs items={crumbs} />
          <p className="eyebrow mt-6">{hero.eyebrow}</p>
          <h1 id="product-title" className="h1 mt-3 text-balance lg:text-[2.6rem] xl:text-[3rem]" data-testid="product-title">{hero.title}</h1>
          <p className="lead mt-4 max-w-xl">{hero.lead}</p>
          <ul className="mt-5 grid gap-2 text-[15px] text-ink" data-testid="product-hero-points">
            {hero.points.map((p) => (
              <li key={p} className="flex items-start gap-2.5">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-maas-soft"><Check className="h-3.5 w-3.5 text-maas" aria-hidden="true" /></span>{p}
              </li>
            ))}
          </ul>
          <div className="mt-7 flex flex-col gap-3">
            <QuoteButton location="product-hero" onderwerp={page.onderwerp} className="sm:self-start" />
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-5">
              <WhatsAppButton location="product-hero" />
              <PhoneLink location="product-hero" />
            </div>
          </div>
        </div>
        <div className="reveal-hero relative lg:col-span-6 [animation-delay:120ms]">
          <div className="frame">
            <MediaImage media={media(hero.media)} priority sizes="(min-width: 1024px) 620px, calc(100vw - 32px)" className="aspect-[4/3] rounded-[14px] sm:aspect-[3/2]" testId="product-hero-image" />
          </div>
          <div className="card absolute -bottom-6 left-4 flex max-w-[290px] items-center gap-3 p-4 pr-5 sm:left-8" style={{ boxShadow: "var(--shadow-2)" }}>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-maas-soft text-maas"><Wrench className="h-5 w-5" aria-hidden="true" /></span>
            <div>
              <p className="text-[15px] font-semibold text-ink">{hero.badge?.title || "Inclusief montage"}</p>
              <p className="text-[13px] text-slate-500">{hero.badge?.text || "Van demontage tot afwerking"}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
